import liteguid from "lite-guid";
import TrackingUtils from "./TrackingUtils";
import TrackingState from "../stores/TrackingState";
import GtmEventsConsumer from "./GtmEventsConsumer";
import TrackingQueue from "./TrackingQueue";
import type { TrackingEvent } from "./TrackingUtils";
import { isEmpty } from "../../utils/utilFunctions";
let eventQueue: any[] = [];
const MAX_QUEUE_SIZE = 50;
export const trackStructuredEvent = function (
	vertical: string,
	service: string,
	eventType: string,
	structuredData?: any,
	hiddenData?: object | null,
	maxQueueSize: number = MAX_QUEUE_SIZE,
	errorCallTreeId?: string,
) {
	eventQueue.push({
		vertical,
		service,
		eventType,
		structuredData,
		hiddenData,
	});
	const sessionStoreInfo = TrackingUtils.getSessionStoreInfo(errorCallTreeId);

	if (!sessionStoreInfo.storeLoaded) {
		if (eventQueue.length > maxQueueSize) {
			eventQueue.forEach((e: any) =>
				unconditionallyTrackStructuredEvent(
					e.vertical,
					e.service,
					e.eventType,
					e.structuredData,
					e.hiddenData,
					errorCallTreeId,
				),
			);
			eventQueue = [];
			// track this session store not loading
			const errorInfo = {
				error: "session store not loading",
				sessionStoreInfo: sessionStoreInfo,
			};
			unconditionallyTrackStructuredEvent(
				"platform",
				"tracking",
				"technical.tracking.error",
				{
					tags: errorInfo,
				},
				null,
				errorCallTreeId,
			);
		}

		return;
	}

	if (eventQueue.length > 0) {
		eventQueue.forEach(e =>
			unconditionallyTrackStructuredEvent(
				e.vertical,
				e.service,
				e.eventType,
				e.structuredData,
				e.hiddenData,
				errorCallTreeId,
			),
		);
		eventQueue = [];
	}
};

const unconditionallyTrackStructuredEvent = function (
	vertical,
	service,
	eventType,
	structuredData: any,
	hiddenData,
	errorCallTreeId?: string,
) {
	TrackingState.createNewContextIfRequired(eventType, structuredData);
	const dispatcherData = {
		sessionStoreInfo: TrackingUtils.getSessionStoreInfo(errorCallTreeId),
		contextInfo: TrackingUtils.getContextInfo(),
		userInfo: TrackingUtils.getUserInfo(),
		testGroups: TrackingUtils.getTestGroups(),
	};
	// Add additional customer information to the tags
	structuredData = structuredData || {};
	structuredData.tags = { ...structuredData.tags, ...TrackingUtils.getCustomerInformation() };
	// Add person information and active context
	structuredData.tags = { ...structuredData.tags, ...TrackingUtils.getPersonInformation() };
	structuredData.tags = { ...structuredData.tags, ...TrackingUtils.getActiveContext() };
	GtmEventsConsumer.trackStructured(eventType, structuredData, hiddenData, dispatcherData);
	const eventIdFromTags = structuredData.tags.eventId;

	if (eventIdFromTags) {
		delete structuredData.tags.eventId;
	}

	const eventId = eventIdFromTags || liteguid.create();
	const trackingEvent: TrackingEvent = {
		vertical,
		service,
		eventType,
		eventId,
		structuredData,
		dispatcherData,
	};
	TrackingQueue.enqueueTrackingEvent(trackingEvent);
};

export const trackForGtmOnly = function (
	vertical: string,
	service: string,
	eventType: string,
	structuredData: any,
	hiddenData: object | null | undefined,
) {
	const dispatcherData = {
		sessionStoreInfo: TrackingUtils.getSessionStoreInfo(),
	};
	const tags = { ...TrackingUtils.getPersonInformation(), ...TrackingUtils.getActiveContext() };

	// only add tags to structuredData if present, else leave structuredData unchanged
	if (!isEmpty(tags)) {
		structuredData = structuredData || {};
		structuredData.tags = structuredData.tags || {};
		structuredData.tags = Object.assign(structuredData.tags, tags);
	}

	GtmEventsConsumer.trackStructured(eventType, structuredData, hiddenData, dispatcherData);
};
export const getCurrentSubContextId = function (): string {
	return TrackingState.getSubContextId();
};
